module.exports = __webpack_public_path__ + "img/Feature.a10f46c4.jpg";